import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ISendNotificationPayload } from '@app-store/slices/notifications/sendNotification'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ISendNotificationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.notification.sendNotification

function* sendNotificationSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/notifications/send`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Notification send successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* sendNotificationSaga(): any {
    yield takeLatest<TaskAction>(onRequest, sendNotificationSagaTask)
}

export default sendNotificationSaga
